/**
 * @author: Marc Riegel <mail@marclab.de>
 * Date: 23.01.13
 * Time: 11:04
 *
 */

module.exports = require('./lib/keygen');
